'use client';

import React, { createContext, useContext, useState } from 'react';

// current active slide context

type CountContextType = [number, React.Dispatch<React.SetStateAction<number>>];

const CountContext = createContext<CountContextType | undefined>(undefined);

export const ActiveSlideProvider = ({ children }: { children: React.ReactNode }) => {
  const state = useState(0);
  return <CountContext.Provider value={state}>{children}</CountContext.Provider>;
};

export const useActiveSlide = () => {
  const context = useContext(CountContext);
  if (!context) {
    throw new Error('useActiveSlide must be used within a ActiveSlideProvider');
  }
  return context;
};

// is dialog open context

type DialogOpenContextType = [boolean, React.Dispatch<React.SetStateAction<boolean>>];

const DialogOpenContext = createContext<DialogOpenContextType | undefined>(undefined);

export const IsDialogOpenProvider = ({ children }: { children: React.ReactNode }) => {
  const state = useState(false);
  return <DialogOpenContext.Provider value={state}>{children}</DialogOpenContext.Provider>;
};

export const useIsDialogOpen = () => {
  const context = useContext(DialogOpenContext);
  if (!context) {
    throw new Error('useIsDialogOpen must be used within a IsDialogOpenProvider');
  }
  return context;
};
